import { jsx as o, jsxs as g } from "react/jsx-runtime";
import y from "classnames";
import { useCallback as i } from "react";
import { useDatePicker as v } from "./index.es851.js";
import c from "./index.es5709.js";
import { ToggleButton as C } from "./index.es8.js";
import { onKeyDownEnterAndSpace as w } from "./index.es526.js";
import { UtilityChevronIcon as K } from "./index.es439.js";
function B({
  dataSource: a,
  activeItem: r,
  addIcon: d,
  className: k,
  displayAsList: p = !1,
  onSelect: m,
  focusDateOptions: t
}) {
  var f;
  const { variant: h } = v(), l = i(
    (e) => {
      m(e), t && t();
    },
    [m, t]
  ), u = i(
    (e) => (s) => {
      w(s, () => l(e.key), !1);
    },
    [l]
  ), b = i(
    (e) => {
      l(e);
    },
    [l]
  );
  if (h === "collapsed" && !p) {
    const e = a.map((n) => ({
      label: n.label,
      value: n.key
    })), s = (f = a.find((n) => n.key === r)) == null ? void 0 : f.key;
    return /* @__PURE__ */ o(
      C,
      {
        size: "default",
        items: e,
        value: s || "",
        onChange: b
      }
    );
  }
  return /* @__PURE__ */ o("div", { className: y(c.list, k), children: a.map((e) => /* @__PURE__ */ g(
    "button",
    {
      className: y(c.item, {
        [c.active]: r === e.key
      }),
      onKeyDown: u(e),
      onClick: () => l(e.key),
      "aria-label": `Select ${e.label}`,
      children: [
        /* @__PURE__ */ o("span", { children: e.label }),
        d && /* @__PURE__ */ o(
          K,
          {
            direction: "left",
            outline: r === e.key ? "white" : "default-gray"
          }
        )
      ]
    },
    e.key
  )) });
}
export {
  B as DatePickerList
};
//# sourceMappingURL=index.es5708.js.map
